import flight from 'flightjs';
import debounce from 'lodash.debounce';

function fullscreenButton() {
    this.defaultAttrs({
        button: '[data-fullscreen-button]',
        className: 'fullscreen-mode',
        noTransitionsClassName: 'notransition',
    });

    this.toggle = function() {
        this.$node.toggleClass(this.attr.className);
    };

    this.enableTransitions = function() {
        this.$node.removeClass(this.attr.noTransitionsClassName);
    };

    this.disableTransitions = function() {
        this.$node.addClass(this.attr.noTransitionsClassName);
    };

    this.after('initialize', function() {
        this.on('click', {
            button: this.toggle,
        });

        this.on(window, 'resize', this.disableTransitions);
        this.on(window, 'resize', debounce(this.enableTransitions.bind(this), 150));
    });
}

export default flight.component(fullscreenButton);



// WEBPACK FOOTER //
// ./src/js/component_ui/fullscreen-mode.js